import React from "react";
import { Heading } from "components/ui/Text";
import { ApiAdminUser } from "utils/api/admin/user";
import { formatDateString } from "utils/date";
import { getAdminUserPlaidStatus } from "store/admin/api/apiSlice";
import * as Styled from "./styled";

interface Props {
  user: ApiAdminUser;
}

const LinkedBankAccount: React.FC<Props> = ({ user }) => {
  const { data: plaidStatus } = getAdminUserPlaidStatus(user.id);

  return (
    <Styled.SectionTile>
      <Heading.H4 tag="h2">Linked Bank Account</Heading.H4>
      {plaidStatus && (
        <Styled.InfoSection>
          <Styled.InfoItem label="Error" value={plaidStatus.error || "n/a"} />
          <Styled.InfoItem
            label="Balance Last Successful Update At"
            value={
              plaidStatus.balancesUpdatedAt
                ? formatDateString(plaidStatus.balancesUpdatedAt)
                : "n/a"
            }
          />
          <Styled.InfoItem
            label="Transactions Last Successful Update At"
            value={
              plaidStatus.transactionsSuccessfulUpdatedAt
                ? formatDateString(plaidStatus.transactionsSuccessfulUpdatedAt)
                : "n/a"
            }
          />
          <Styled.InfoItem
            label="Transactions Last Failed Update At"
            value={
              plaidStatus.transactionsFailUpdatedAt
                ? formatDateString(plaidStatus.transactionsFailUpdatedAt)
                : "n/a"
            }
          />
          <Styled.InfoItem
            label="Plaid Item ID"
            value={plaidStatus.plaidItemId || "n/a"}
          />
        </Styled.InfoSection>
      )}
    </Styled.SectionTile>
  );
};

export default LinkedBankAccount;
